import { Box, Typography, TypographyProps } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';
import { useHighlightUrl } from 'framework/HighlightUrl';
import { useLocation } from 'react-router-dom';

interface NavigationItemLabelProps {
  name: string;
  url?: string;
  isAlpha?: boolean;
  isBeta?: boolean;
  color?: TypographyProps['color'];
}

const NEW_ITEMS_INDICATOR_LABEL = 'Has new items';

const NavigationItemLabel = ({ name, url, isAlpha, isBeta, color }: NavigationItemLabelProps) => {
  const location = useLocation();
  const { hasHighlightUrl } = useHighlightUrl();
  const badgeText = isAlpha ? 'Alpha' : isBeta ? 'Beta' : '';
  const shouldShowNewItemsIndicator = url ? hasHighlightUrl(url) : hasHighlightUrl(location.pathname);
  const hasIndicators = badgeText || shouldShowNewItemsIndicator;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', minWidth: 0 }}>
      {hasIndicators ? (
        <Box
          sx={{
            position: 'absolute',
            right: badgeText && shouldShowNewItemsIndicator ? '-25px' : '-10px',
            top: shouldShowNewItemsIndicator && !badgeText ? '2px' : '-8px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          {badgeText ? (
            <Badge
              color="primary"
              sx={{
                minHeight: 'auto',
                fontSize: 10,
                '.MuiChip-label': {
                  fontWeight: 'normal',
                  overflow: 'visible',
                  textOverflow: 'initial',
                  p: '2px 4px',
                },
              }}
            >
              {badgeText}
            </Badge>
          ) : null}
          {shouldShowNewItemsIndicator ? (
            <Box
              aria-label={NEW_ITEMS_INDICATOR_LABEL}
              sx={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                flexShrink: 0,
              }}
            />
          ) : null}
        </Box>
      ) : null}
      <Typography color={color}>{name}</Typography>
    </Box>
  );
};

export default NavigationItemLabel;
